import React from 'react';
import PropTypes from 'prop-types';

const BlockQuote = (props) => (
  <blockquote className="block-quote" dangerouslySetInnerHTML={{ __html: props[props.src] }} />
);

BlockQuote.propTypes = {
  src: PropTypes.string
};

export default BlockQuote;
